import * as React from "react";
import {Box, Typography} from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EmptyState from "../../components/state/EmptyState";

export function EmptyDocumentsTab({label}) {
    return (
        <Box sx={{border: '1px solid', borderColor: 'divider', borderRadius: 1, backgroundColor: 'background.paper'}}>
            <EmptyState icon={<InboxIcon/>} title={label}/>
        </Box>
    );
}

export function EmptyDocumentDetail({label}) {
    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, padding: '10px 12px'}}>
            <InfoOutlinedIcon fontSize="small" sx={{color: 'primary.main'}}/>
            <Typography variant="body2" color="text.primary">{label}</Typography>
        </Box>
    );
}
